import { render, staticRenderFns } from "./FileId.vue?vue&type=template&id=1ec787e0"
import script from "./FileId.vue?vue&type=script&lang=js"
export * from "./FileId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports